import React from 'react';
import FourthStep from './FourthStep';

const Grade11Form4 = ({initialState, secondState, thirdState, handleCurrentStep }) => {
  return (
    <FourthStep
      initialState={initialState}
      secondState={secondState}
      thirdState={thirdState}
      handleCurrentStep={handleCurrentStep}
    />
  );
};

export default Grade11Form4;